import { render, staticRenderFns } from "./FilterCategory.vue?vue&type=template&id=95d2d7e4&"
import script from "./FilterCategory.vue?vue&type=script&lang=js&"
export * from "./FilterCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports